<template>
    <div class="content">
      <h3 style="margin-bottom:20px;">温馨提示:取得的证据如果有多条应该是:相关证据1、相关证据2、相关证据3.....等</h3>
        <el-row :gutter="20">
          <el-col :span="7">
              <ul class="zfmb">
                <li v-for="(item,index) in zfmbList" :key="index">
                  <p @click="getActive(index)"><i :class="isActive == index?'icon2':'icon1'" style="color:#ffaf47;"></i><b>{{item.zylbMc}}</b></p>
                  <div v-show="isActive == index" class="zfmb2">
                    <span v-for="(itema,i) in item.info" :key="i" :class="isActive2 == i?'dqSpan':''" @click="getXunwennr(itema,i)">{{itema.mcjianxie}}</span>
                  </div>
                </li>
              </ul>
          
            </el-col>
            <el-col :span="17">
              <el-table v-loading="loading" :data="zhengjuList" style="height:310px;overflow-y: auto;margin-bottom:10px;">
                <el-table-column  align="center" :show-overflow-tooltip="true" type="index"  label="序号" width="60"/>
                <el-table-column label="证据内容" prop="nr" />
                <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="50" >
                    <template slot-scope="scope">
                      <el-button
                    size="small"
                    type="text"
                    @click="handleDelect(scope.$index)"
                >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
                <el-form ref="form" :model="form" class="flxz">
                    <el-col :span="23">
                    <el-form-item>
                      <el-input type="textarea" :rows="8" placeholder="" v-model="form.content" :style="{width:'100%'}" @input="renew($event)" style="white-space: pre-wrap;word-break: break-all;"></el-input>
                    </el-form-item>
                    </el-col>
                    <el-col :span="23">
                    <el-form-item size="large" label-width="0" style="text-align:center;">
                      <el-button type="danger" @click="addZj">添加证据</el-button>
                        <el-button type="primary" @click="submit">确定</el-button>
                        <el-button type="info" @click="cancel">取消</el-button>
                    </el-form-item>
                    </el-col>
                </el-form>
            </el-col>
            
        </el-row>
        <el-dialog title="添加证据" :visible.sync="open" width="800px" append-to-body :close-on-click-modal="false">
          <el-form :model="form1" ref="form1" label-width="100px" class="xzform">  
            <el-form-item label="主体资格:" prop="ztzg">
              <el-select v-model="form1.ztzg" clearable multiple placeholder="请选择" size="small" style="width:92%;" @change="getZg()">
                <el-checkbox v-model="checked1" @change="selectAll1()" style=" text-align: right; width: calc(100% - 20px); padding-right: 20px; line-height: 30px;">全选</el-checkbox>
                <el-option
                    v-for="dict in ztzgOptions"
                    :key="dict.id"
                    :label="dict.label"
                    :value="dict.value"
                    ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="现场检查:" prop="xcjc">
              <el-select v-model="form1.xcjc" clearable multiple placeholder="请选择" size="small" style="width:92%;" @change="getXc()">
                <el-checkbox v-model="checked2" @change="selectAll2()" style=" text-align: right; width: calc(100% - 20px); padding-right: 20px; line-height: 30px;">全选</el-checkbox>
                <el-option
                    v-for="dict in xcjcOptions"
                    :key="dict.id"
                    :label="dict.label"
                    :value="dict.value"
                    ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="责令整改:" prop="zlzg">
              <el-select v-model="form1.zlzg" clearable multiple placeholder="请选择" size="small" style="width:92%;" @change="getZl()">
                <el-checkbox v-model="checked3" @change="selectAll3()" style=" text-align: right; width: calc(100% - 20px); padding-right: 20px; line-height: 30px;">全选</el-checkbox>
                <el-option
                    v-for="dict in zlzgOptions"
                    :key="dict.id"
                    :label="dict.label"
                    :value="dict.value"
                    ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item  style="margin-top:20px; text-align:right;">
              <el-button type="primary" size="small" @click="shengcheng()">生成</el-button>
            </el-form-item>
            <el-form-item label-width="0">
              <el-input type="textarea" rows="5" v-model="form1.content" clearable size="small" />
            </el-form-item>
          </el-form>
            <div style="margin-top:20px; text-align:center;">
                <el-button type="primary" size="small" @click="zdyblTj">确  定</el-button>
                <el-button type="info" size="small" @click="open = false">取  消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
    export default {
      components: {},
      props: ['text'],
      data() {
        return {
          form:{
            content:'',
          },
          isActive:'-1',
          isActive2:'-1',
          zfmbList:[],
          zhengjuList:[],
          loading:false,
          open:false,
          form1:{
            content:'',
            zt:'',
            xc:'',
            zl:'',
            ztzg:[],
            xcjc:[],
            zlzg:[]
          },
          ztzgOptions:[
            {id:0,type:"主体资格",info:"经营资格",value:"营业执照复印件",label:"营业执照复印件"},
            {id:1,type:"主体资格",info:"主体资格",value:"当事人身份证复印件",label:"当事人身份证复印件"},
            {id:2,type:"主体资格",info:"经营资格",value:"卫生许可证复印件",label:"卫生许可证复印件"},
            {id:3,type:"主体资格",info:"主体资格",value:"法定代表人身份证复印件",label:"法定代表人身份证复印件"},
            {id:4,type:"主体资格",info:"代理资格",value:"代理人身份证复印件",label:"代理人身份证复印件"},
            {id:5,type:"主体资格",info:"代理资格",value:"授权委托书",label:"授权委托书"},
            {id:6,type:"主体资格",info:"卫生监督投诉举报受理表",value:"卫生监督投诉举报受理表",label:"卫生监督投诉举报受理表"},
          ],
          xcjcOptions:[
            {id:0,type:"现场检查",info:"违法事实",value:"现场照片",label:"现场照片"},
            {id:1,type:"现场检查",info:"违法事实",value:"现场笔录",label:"现场笔录"},
            {id:2,type:"现场检查",info:"违法事实",value:"非产品样品采样记录",label:"非产品样品采样记录"},
            {id:3,type:"现场检查",info:"违法事实",value:"检验检测报告",label:"检验检测报告"},
            {id:4,type:"现场检查",info:"违法事实",value:"检验结果告知书",label:"检验结果告知书"},
            {id:5,type:"现场检查",info:"违法事实",value:"询问笔录",label:"询问笔录"},
          ],
          zlzgOptions:[
            {id:0,type:"责令整改",info:"整改及整改结果",value:"卫生监督意见书",label:"卫生监督意见书"},
            {id:1,type:"责令整改",info:"整改及整改结果",value:"整改报告",label:"整改报告"},
          ],
          checked1:false,
          checked2:false,
          checked3:false,
          dqArr:[],
          baseUrl:''
        }
      },
      watch:{
        text(){
          
          this.isActive2 = '-1'
        }
      },
      created() {
        console.log(this.text)
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.baseUrl = user.baseUrl
        this.getList();
      },
      async mounted() {
        if(this.text){
          this.$set(this.form,'content',this.text)
          console.log(this.form.content)
          let arr = this.form.content.split('\n')
          console.log(arr)
          arr.forEach((item,index) => {
            this.zhengjuList.push({xh:index+1,nr:item.slice(2)})
          })
        }else{
          this.$set(this.form,'content','')
        }
      },
      methods: {
        getList(){
          axios({
                method: 'post',
                url: this.baseUrl+`/login/getZfmb`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    leibie:'本案取得的证据',
                    find:''
                }
            })
            .then(response => {
                this.zfmbList = response.data.data || []
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
        },
        renew(e){
          this.$forceUpdate()
        },
        submit(){
          this.$confirm("您确定本案取得的证据准确不需要修改了吗？", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
          })
          .then(async () => {
            this.dqArr = this.zhengjuList
            this.$emit("handleBackZhengju",this.form.content)
          })
        },
        cancel(){
          this.$emit("zhengjuTk",false)
        },

        getActive(index){
          if(this.isActive == index){
            this.isActive = '-1'
          }else{
            this.isActive = index
          }
        },
        getXunwennr(itema,i){
          this.isActive2 = i
          if(this.form.content.indexOf(itema.mc) != '-1'){
            this.$message.error('不能重复添加')
          }else{
            if(itema.mc.indexOf('<br/>') != -1){
              itema.mc = itema.mc.replace(/<br\s*\/?>/gi, '\n');
            }
            if(this.form.content){
              let zf = this.form.content.substr(this.form.content.length - 1,1)
              let nr = zf != '\n' ? '\n' +  itema.mc : itema.mc
              this.form.content =  this.form.content + nr
            }else{
              this.form.content = itema.mc
            }
          }
        },
        jcth(){
          
        },
        addZj(){
          this.open = true
          this.form1 = {
            zt:'',
            xc:'',
            zl:'',
            ztzg:[],
            xcjc:[],
            zlzg:[]
          }
        },
        selectAll1(){
          this.form1.ztzg = []
          if(this.checked1){
            this.ztzgOptions.map((item) => {
              this.form1.ztzg.push(item.value);
            });
          }else{
            this.form1.ztzg = []
          }
        },
        selectAll2(){
          this.form1.xcjc = []
          if(this.checked2){
            this.xcjcOptions.map((item) => {
              this.form1.xcjc.push(item.value);
            });
          }else{
            this.form1.xcjc = []
          }
        },
        selectAll3(){
          this.form1.zlzg = []
          if(this.checked3){
            this.zlzgOptions.map((item) => {
              this.form1.zlzg.push(item.value);
            });
          }else{
            this.form1.zlzg = []
          }
        },
        getZg(){
          console.log(this.form1.ztzg)
        },
        getXc(){
          console.log(this.form1.xcjc)
        },
        getZl(){
          console.log(this.form1.zlzg)
        },
        shengcheng(){
          this.form1.zt = ''
          this.form1.xc = ''
          this.form1.zl = ''
          if(this.form1.ztzg.length > 0){
            this.form1.zt = this.form1.ztzg.join('、')
          }
          if(this.form1.xcjc.length > 0){
            this.form1.xc = this.form1.xcjc.join('、')
            this.form1.xc = this.form1.zt ? '、'+this.form1.xc :this.form1.xc
          }
          if(this.form1.zlzg.length > 0){
            this.form1.zl = this.form1.zlzg.join('、')
            this.form1.zl = this.form1.xc ? '、'+this.form1.zl :this.form1.zl
          }
          console.log(this.form1.zt,this.form1.xc,this.form1.zl)
          let n1='当事人的'
          if(this.form1.zt || this.form1.xc){
            n1='当事人的'
          }else{
            n1='本机关责令当事人'
          }
          let n2 = this.form1.zt ? '经营资格' : ''
          let n3 = this.form1.xc ? (this.form1.zt ? '、违法事实':'违法事实') : ''
          let n4 = this.form1.zl ? (this.form1.xc ? '、整改及整改结果':'整改及整改结果') : ''
          let nr = this.form1.zt + this.form1.xc + this.form1.zl + ',证明'+n1+n2+n3+n4
          this.$set(this.form1,'content',nr)          
        },
        zdyblTj(){
          if(this.form1.content){
            this.zhengjuList.push({xh:this.zhengjuList.length,nr:this.form1.content})
            let nr =  this.zhengjuList.length+'.'+this.form1.content
            if(this.form.content){
              let zf = this.form.content.substr(this.form.content.length - 1,1)
              nr = zf != '\n' ? '\n' + nr : nr
              this.form.content = this.form.content + nr 
            }else{
              this.form.content = nr
            }
          }
          this.open = false
        },
        handleDelect(i){
          console.log(i)
          this.zhengjuList.splice(i,1)
        },
      }
    }
</script>

<style  scoped>
.zfmb{ border:1px solid #DCDFE6; padding: 20px;max-height: 500px; overflow-y: auto;}
.zfmb li{line-height: 40px;}
.zfmb li p i{ width: 22px; height: 20px;float: left;; margin:10px 7px 0 0;}
.zfmb li p b{ cursor: pointer;}
.icon1{ background: url(../../../assets/images/wjjm.png);}
.icon2{ background: url(../../../assets/images/wjjm-a.png);}
.zfmb2{width: 100%;}
.zfmb2 span{ cursor: pointer; display: block; padding-left: 30px; background: url(../../../assets/images/wjj.png) no-repeat center left; margin-left: 30px;}
.zfmb2 span.dqSpan{color:#0C80E8;}

.el-form >>> .el-textarea.is-disabled .el-textarea__inner { color: #333 !important;}
</style>